import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  toggle(event) {
    event.preventDefault();

    if (this.inputTarget.type === "password") {
      this.inputTarget.type = "text";
    } else {
      this.inputTarget.type = "password";
    }
  }
}
